import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import AgentAndCompanyFilters from '../../Component/AgentAndCompanyFilters';
import AgentCard from '../../Component/AgentCard/AgentCard';
import BannerImageAd from '../../Component/BannerImageAd';
import CompanyCard from '../../Component/CompanyCard/CompanyCard';
import DropDown from '../../Component/DropDown/DropDown';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import HeroSection from '../../Component/HeroSection';
import { Loader } from '../../Component/Loader';
import NoData from '../../Component/NoData/NoData';
import { PaginationComponent } from '../../Component/Pagination/Pagination';
import { discardUndefinedOrNullValues, imageUrl, recordsLimit } from '../../config/apiUrl';
import { companyAgentFilterOptions } from '../../constant/commonData';
import { useGetAllPublicCompanyOrAgentsMutation } from '../../store/apiSlice/apiSlice';
import { getSelectedLanguagePage } from '../../utils/helpers';
import classes from './AgentOrCompany.module.css';

function AgentOrCompany() {
  const { t } = useTranslation('agentsOrCompany');
  const { t: t1 } = useTranslation('agentOrCompanyDetail');
  const navigate = useNavigate();
  const [featuredFilterValue, setFeaturedFilterValue] = useState('');
  const [searchParams] = useSearchParams();
  const tabDefaultValue = searchParams.get('tab');
  const [selectedTab, setSelectedTab] = useState(tabDefaultValue || 'agents');
  const [page, setPage] = useState(1);
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { cmsPages } = useSelector((state) => state.commonReducer);
  const pageData = getSelectedLanguagePage(selectedLanguage, cmsPages, 'agentsPage');

  const [filters, setFilters] = useState({
    province: null,
    town: null,
    neighborhood: null,
    nearby: false,
    lng: null,
    lat: null,
    languages: []
  });
  const [searchText, setSearchText] = useState('');

  const [getData, { isLoading, data }] = useGetAllPublicCompanyOrAgentsMutation();

  const { allBanners } = useSelector((state) => state.commonReducer);

  const horizontalBanners = allBanners?.find(
    (item) =>
      item?.page === (selectedTab === 'agents' ? 'agents' : 'companies') &&
      item?.bannerType == 'horizontal'
  );

  const getAgentsOrCompany = async (
    pg = page,
    type = selectedTab,
    sortType = featuredFilterValue?.value,
    moreFilters = {}
  ) => {
    const filtersData = {
      type: type == 'agents' ? 'agent' : 'company',
      ...moreFilters,

      ...(sortType ? { sortType: sortType } : {})
    };
    await getData({ data: filtersData, page: pg });
  };

  const handleSearch = async () => {
    const newData = {
      lan: selectedLanguage,
      province: filters?.province?._id,
      town: filters?.town?._id,
      neighborhood: filters?.neighborhood?._id,
      nearby: filters?.nearby,
      ...(filters?.nearby || searchText
        ? {
            lng: filters?.lng,
            lat: filters?.lat
          }
        : {}),
      language: filters?.languages?.map((e) => e?.[selectedLanguage])
    };
    setPage(1);

    await getAgentsOrCompany(
      1,
      selectedTab,
      featuredFilterValue?.value,
      discardUndefinedOrNullValues(newData)
    );
  };
  useEffect(() => {
    getAgentsOrCompany();
  }, []);

  return (
    <>
      <style>
        {`
        .smDropdown__indicator{
            padding: 0px 8px;
        }
        .smDropdown__control{
            border-radius: 0;
        }
            @media (max-width: 768px) {
            .HeroSection_heroContainer__PxMTr{
            padding-inline: 25px !important;
            }
            }
            @media (max-width: 450px) {
            .agentAndCompanyFilters_row__8uBY1{
            flex-direction: column !important;
         
            }
            .agentAndCompanyFilters_tabs__xu8FK {
            flex-direction: column !important;
               width: 100% !important;
            }
    .agentAndCompanyFilters_otherOptions__ZUGv8{
    margin-top: 65px !important;
    }
            
            }
     @media (max-width: 400px) {
            .HeroSection_heroContainer__PxMTr{
            padding-inline: 10px !important;
            }
        `}
      </style>
      <div className={classes.page}>
        <Header containerClass="" />

        <HeroSection
          center
          bgImage={imageUrl(pageData?.hero?.bg)}
          containerClass={classes.heroContainerClass}
          className={classes.agentAndCompanyMain}
          >
        
          <AgentAndCompanyFilters
            containerClass={classes.filtersContainer}
            selectedTab={selectedTab}
            t={t}
            setSelectedTab={(e) => {
              setSelectedTab(e);
              setFilters({
                province: null,
                town: null,
                neighborhood: null,
                nearby: false,
                lng: null,
                lat: null,
                languages: []
              });
              setPage(1);
              getAgentsOrCompany(1, e);
            }}
            filters={filters}
            setFilters={setFilters}
            onSearch={() => {
              handleSearch();
            }}
            setSearchText={setSearchText}
            searchText={searchText}
          />
        </HeroSection>

        {/* Body */}
        <div className={classes?.pagePadding}>
          <Container className="">
            {/* filter */}
            <div className={classes?.dataStripRight}>
              <div>
                <p>
                  {data?.data?.length}{' '}
                  {selectedTab === 'agents' ? t1('company.agents') : t('filters.companies')}
                </p>
              </div>
              <div>
                <span>{t('sortBy')}</span>
                <DropDown
                  customStyle={{ border: 'none' }}
                  classNamePrefix={'smDropdown'}
                  options={companyAgentFilterOptions}
                  value={featuredFilterValue}
                  setValue={(e) => {
                    setFeaturedFilterValue(e);
                    setPage(1);
                    getAgentsOrCompany(1, selectedTab, e?.value);
                  }}
                  optionLabel={[selectedLanguage]}
                  optionValue={'value'}
                  placeholder={t('sortByPlaceholder')}
                />
              </div>
            </div>

            {/* Mapper */}
            {isLoading ? (
              <Loader />
            ) : (
              <>
                {selectedTab === 'agents' && (
                  <>
                    <Row className={classes.innerRow}>
                      {data?.data?.length == 0 ? (
                        <NoData text={t('noAgents')} />
                      ) : (
                        data?.data?.map((e, i) => {
                          return (
                            <Col key={`${e?._id}-${i}`} xxl={3} xl={3} md={4} sm={6} xs={12}>
                              <AgentCard
                                data={e}
                                index={i}
                                onClick={(agentData) => navigate(`/agents/${agentData?.slug}`)}
                              />
                            </Col>
                          );
                        })
                      )}
                    </Row>
                    {!!data?.data?.length && (
                      <div className={`${[classes.pagination, 'jCenter'].join(' ')}`}>
                        <PaginationComponent
                          totalPages={Math.ceil(data?.totalRecords / recordsLimit)}
                          currentPage={page}
                          setCurrentPage={(e) => {
                            getAgentsOrCompany(e);
                            setPage(e);
                          }}
                        />
                      </div>
                    )}
                  </>
                )}
                {selectedTab === 'company' && (
                  <>
                    <Row className={classes.innerRow}>
                      {data?.data?.length == 0 ? (
                        <NoData text={t('noCompany')} />
                      ) : (
                        data?.data?.map((e, i) => {
                          return (
                            <Col key={`${e?._id}-${i}`} xxl={3} xl={3} md={4} sm={6} xs={12}>
                              <CompanyCard
                                data={e}
                                index={i}
                                onClick={(companyData) => navigate(`/company/${companyData?.slug}`)}
                              />
                            </Col>
                          );
                        })
                      )}
                    </Row>
                    {!!data?.data?.length && (
                      <div className={`${[classes.pagination, 'jCenter'].join(' ')}`}>
                        <PaginationComponent
                          totalPages={Math.ceil(data?.totalRecords / recordsLimit)}
                          currentPage={page}
                          setCurrentPage={(e) => {
                            getAgentsOrCompany(e);
                            setPage(e);
                          }}
                        />
                      </div>
                    )}
                  </>
                )}

                {/* Banner Ad */}
                {horizontalBanners?.image && (
                  <BannerImageAd
                    link={horizontalBanners?.link}
                    image={imageUrl(horizontalBanners?.image)}
                    className={classes.horizontalBanner}
                  />
                )}
              </>
            )}
          </Container>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default AgentOrCompany;

